import {
  Message
} from 'element-ui'
import SuperagentApi from '../assets/utils/superagent'

const diyCodeServer = Wiz.globalSettings.globalConfig.diyCodeServer
const token = Wiz.AuthHooks.GetToken()

const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
  'X-Wiz-Tenant-Id': JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || '',
}
const superagentApi = new SuperagentApi({
  baseUrl: diyCodeServer
})

export default class DiyCodeService {
  // 获取低代码分页数据
  static async getPipesData(data) {
    const [err, res] = await superagentApi.post('/api/FormEngine/getTableData', {
      data,
      headers
    })
    if (res.code !== 200) {
      res.Msg && Message.error(res.Msg)
    }
    return [err, res]
  }
  static async addFormData(data) {
    const [err, res] = await superagentApi.post('/api/FormEngine/addFormData', {
      data,
      headers
    })
    return [err, res]
  }
  static async uptFormData(data) {
    const [err, res] = await superagentApi.post('/api/FormEngine/uptFormData', {
      data,
      headers
    })
    return [err, res]
  }
  static async delFormData(data) {
    const [err, res] = await superagentApi.post('/api/FormEngine/delFormData', {
      data,
      headers
    })
    return [err, res]
  }
  static async GetFormData(data) {
    const [err, res] = await superagentApi.post('/api/FormEngine/GetFormData', {
      data,
      headers
    })
    return [err, res]
  }
  static async AddDiyTableRowBatch(data) {
    const [err, res] = await superagentApi.post('/api/diytable/AddDiyTableRowBatch', {
      data: {
        _List: data
      },
      headers: {
        ...headers,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })

    return [err, res]
  }
  static async DelDiyTableRowBatch(data) {
    const [err, res] = await superagentApi.post('/api/diytable/DelDiyTableRowBatch', {
      data: {
        _List: data
      },
      headers: {
        ...headers,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })

    return [err, res]
  }
  static async UptFormDataBatch(data) {
    const [err, res] = await superagentApi.post('/api/FormEngine/uptFormDataBatch', {
      data,
      headers
    })

    return [err, res]
  }

  static async ApiEngine(data) {
    const [err, res] = await superagentApi.post('/api/ApiEngine/Run', {
      data,
      headers
    })

    return [err, res]
  }
}
